import { render, staticRenderFns } from "./NoteCapture.vue?vue&type=template&id=3731dc0c&scoped=true"
import script from "./NoteCapture.vue?vue&type=script&lang=js"
export * from "./NoteCapture.vue?vue&type=script&lang=js"
import "./NoteCapture.vue?vue&type=style&index=0&id=3731dc0c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3731dc0c",
  null
  
)

export default component.exports